import { render } from "./LearningModule.vue?vue&type=template&id=51b59582&scoped=true"
import script from "./LearningModule.vue?vue&type=script&lang=js"
export * from "./LearningModule.vue?vue&type=script&lang=js"

import "./LearningModule.vue?vue&type=style&index=0&id=51b59582&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b59582"]])

export default __exports__